// extracted by mini-css-extract-plugin
export default {"tooltipLink":"ToolDetailsFieldsTableRow_tooltipLink__w0YUp"};